import { createFileRoute, redirect } from '@tanstack/react-router';

/** Content has no overview of its own; pages are the first screen. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/s/$storeId/content/pages', params: { storeId: params.storeId } });
  },
});
